import { LANGUAGE, LANGUAGE_EN, LANGUAGE_FR } from "./i18n";
import countries from "i18n-iso-countries";

countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

interface AllCountriesResult {
  ALL_COUNTRIES_NAME: string[];
  ALL_COUNTRIES_CODE: string[];
  NAMES_BY_ISO_CODE: Record<string, string>;
}

let cache: AllCountriesResult | null = null;

export function getCountriesByLanguage(): AllCountriesResult {
  if (cache) {
    return cache;
  }

  const finalLanguage = LANGUAGE === LANGUAGE_FR ? LANGUAGE_FR : LANGUAGE_EN;
  const countriesObject = countries.getNames(finalLanguage, {
    select: "official"
  });

  const COUNTRIES: Array<{
    code: string;
    name: string;
  }> = [];

  Object.keys(countriesObject).forEach((key) => {
    COUNTRIES.push({
      code: key,
      name: countriesObject[key]
    });
  });

  COUNTRIES.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });

  const NAMES_BY_ISO_CODE: Record<string, string> = {};

  COUNTRIES.forEach((c) => {
    NAMES_BY_ISO_CODE[c.code] = c.name;
  });

  cache = {
    ALL_COUNTRIES_NAME: COUNTRIES.map((c) => c.name),
    ALL_COUNTRIES_CODE: COUNTRIES.map((c) => c.code),
    NAMES_BY_ISO_CODE
  };
  return cache;
}
